import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Button,
  message,
  Divider,
  Input,
  Tooltip,
  Form,
  Modal,
  Select,
  Space,
  InputNumber,
} from "antd";
import {
  EditOutlined,
  PlusOutlined,
  DeleteOutlined,
  UnorderedListOutlined,
  OrderedListOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import { TableCustom } from "../../../components/table";
import http from "../../../services/http";
const { Text } = Typography;
const { TextArea } = Input;

// STATUS
const options_status = [
  { value: 0, label: "Inativo" },
  { value: 1, label: "Ativo" },
];

// TIPO
const options_tipo = [
  { value: 1, label: "Objetiva" },
  { value: 2, label: "Descritiva" },
];

// EXIBIÇÃO
const options_exibicao = [
  { value: 1, label: "Todos" },
  { value: 2, label: "Somente Autoavaliação" },
];

// RESTRITO
const options_restrito = [
  { value: 0, label: "Não" },
  { value: 1, label: "Sim" },
];

// TIPO
const array_tipo = {
  ["1"]: "Objetiva",
  ["2"]: "Descritiva",
};

// EXIBIÇÃO
const array_exibicao = {
  ["1"]: "Todos",
  ["2"]: "Somente Autoavaliação",
};

export const AvaliacoesCadQuestoes = () => {
  const { id_grupo, id_formulario } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();
  const tipo = Form.useWatch("tipo", form);

  // ID ALTERAÇÃO
  const [idAlt, setIdAlt] = useState(0);

  // PRODUTO
  const [grupo, setGrupo] = useState(null);

  useEffect(() => {
    if (id_grupo) {
      carregarGrupo(id_grupo);
      listarQuestoes(id_grupo);
    }
  }, [id_grupo]);

  // CARREGAR GRUPO
  const carregarGrupo = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/avaliacoes_grupos/carregar/${id}`, []);
    if (api.statusCode === 200) {
      setGrupo(api?.response?.data);
    } else {
      navigate("/avaliacoes/formularios");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR
  const listarQuestoes = async (id) => {
    setLoading(true);
    const api = await http("get", `v1/avaliacoes_questoes/listar/${id}`, []);
    if (api.statusCode === 200) {
      setDados(api?.response?.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CADASTRAR
  const cadastrarQuestao = async (formulario) => {
    if (!formulario?.id_avaliacoes_cad_grupos) return;
    setLoading(true);
    const api = await http("post", `v1/avaliacoes_questoes/adicionar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro cadastrado com sucesso!");
      setShowModal(false);
      resetForm();
      listarQuestoes(id_grupo);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // ALTERAR
  const alterarQuestao = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/avaliacoes_questoes/alterar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro alterado com sucesso!");
      setShowModal(false);
      resetForm();
      listarQuestoes(id_grupo);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR
  const carregarQuestao = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/avaliacoes_questoes/carregar/${id}`, []);
    if (api.statusCode === 200) {
      setShowModal(true);
      resetForm();
      form.setFieldsValue({
        tipo: api?.response?.data?.tipo,
        exibicao: api?.response?.data?.exibicao,
        descricao: api?.response?.data?.descricao,
        restrito: api?.response?.data?.restrito,
        dica: api?.response?.data?.dica,
        ordem: api?.response?.data?.ordem,
        status: api?.response?.data?.status,
      });
      setIdAlt(api.response.data.id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DELETAR
  const deletarQuestao = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/avaliacoes_questoes/deletar`, { id: id });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      listarQuestoes(id_grupo);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RESET FORM
  const resetForm = () => {
    form.resetFields();
    setIdAlt(0);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Descrição",
      dataIndex: "descricao",
    },
    {
      title: "Dica",
      dataIndex: "dica",
      ellipsis: true,
    },
    {
      title: "Tipo",
      dataIndex: "tipo",
      render: (_, e) => array_tipo[e.tipo],
      renderText: (e) => array_tipo[e.tipo],
    },
    {
      title: "Exibição",
      dataIndex: "exibicao",
      render: (_, e) => array_exibicao[e.exibicao],
      renderText: (e) => array_exibicao[e.exibicao],
    },
    {
      title: "Ordem",
      dataIndex: "ordem",
    },
    {
      dataIndex: "status",
      title: "Status",
      width: 100,
      render: (_, e) => (e.status === 1 ? "Ativo" : "Inativo"),
      renderText: (e) => (e.status === 1 ? "Ativo" : "Inativo"),
    },
    {
      dataIndex: "acoes",
      title: "Ações",
      width: 100,
      sorter: false,
      render: (_, e) => (
        <Space.Compact>
          <Tooltip title="Editar">
            <Button loading={loading} onClick={() => carregarQuestao(e.id)} icon={<EditOutlined />} />
          </Tooltip>
          <Tooltip title="Excluir">
            <Button
              danger
              loading={loading}
              icon={<DeleteOutlined />}
              onClick={() => {
                modal.confirm({
                  title: "Deseja deletar este registro?",
                  okText: "Sim",
                  cancelText: "Cancelar",
                  onOk() {
                    deletarQuestao(e.id);
                  },
                });
              }}
            />
          </Tooltip>
        </Space.Compact>
      ),
    },
  ];

  // SUBMIT FORM
  const onSubmit = (formulario) => {
    formulario.id_avaliacoes_cad_grupos = id_grupo && id_grupo;

    if (formulario?.tipo === 1) {
      formulario.restrito = 0;
    }

    if (idAlt > 0) {
      formulario.id = idAlt;
      alterarQuestao(formulario);
    } else {
      cadastrarQuestao(formulario);
    }
  };
  return (
    <Row align="middle" justify="center" className="content-row">
      <Modal
        title={
          <Text style={{ fontSize: 20 }}>
            <EditOutlined /> {idAlt > 0 ? "Editar" : "Adicionar"} Grupo
          </Text>
        }
        open={showModal}
        onOk={() => form.submit()}
        okText="Salvar"
        width={1200}
        okButtonProps={{ size: "large", loading: loading }}
        cancelButtonProps={{ size: "large", loading: loading }}
        onCancel={() => {
          setShowModal(false);
          resetForm();
        }}>
        <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="tipo" label="Tipo" rules={[{ required: true, message: "Selecione o tipo!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione o tipo"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={options_tipo}
                />
              </Form.Item>
            </Col>
            {tipo === 2 && (
              <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  name="restrito"
                  label="Restrito"
                  rules={[{ required: true, message: "Selecione a restrição!" }]}>
                  <Select
                    size="large"
                    placeholder="Selecione a restrição"
                    disabled={loading}
                    style={{ width: "100%" }}
                    options={options_restrito}
                  />
                </Form.Item>
              </Col>
            )}

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="exibicao"
                label="Tipo Exibição"
                rules={[{ required: true, message: "Selecione o tipo exibição!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione o tipo exibição"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={options_exibicao}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="descricao"
                label="Descrição"
                rules={[{ required: true, message: "Digite a descrição!" }]}>
                <Input size="large" disabled={loading} placeholder="Informe a descrição" />
              </Form.Item>
            </Col>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="dica" label="Dica" rules={[{ required: true, message: "Digite a dica!" }]}>
                <TextArea
                  size="large"
                  autoSize={{ minRows: 3, maxRows: 5 }}
                  placeholder="Informe a dica"
                  disabled={loading}
                />
              </Form.Item>
            </Col>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="ordem" label="Ordem" rules={[{ required: true, message: "Digite a ordem!" }]}>
                <InputNumber
                  className="input-number"
                  precision={0}
                  size="large"
                  min={1}
                  max={1000}
                  disabled={loading}
                  placeholder="Informe a ordem"
                />
              </Form.Item>
            </Col>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="status" label="Status" rules={[{ required: true, message: "Selecione o status!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione o status"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={options_status}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>

      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage
              title="Avaliações"
              onClickBack={() => navigate(`/avaliacoes/formularios/grupos/${id_formulario}`)}
            />
            <HeaderTitle
              title="Avaliações Gestão Questões"
              subtitle={
                <Text italic>
                  <UnorderedListOutlined /> {grupo?.descricao ?? ""}
                </Text>
              }
              icon={<OrderedListOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <TableCustom
                extraHeaderComponents={
                  <Tooltip title="Adicionar Registro">
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={() => {
                        setShowModal(true);
                        resetForm();
                      }}
                      loading={loading}>
                      Novo
                    </Button>
                  </Tooltip>
                }
                loading={loading}
                columns={columns}
                dataSource={dados}
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
